import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISetting, ISettingState } from "./settingModel";
import {
  findAllSetting,
  findByIDSetting,
  insertSetting,
  updateSetting,
  deleteSetting,
  activeInactiveSetting,
} from "./setting.service";

const initialState: ISettingState = {
  loading: false,
  formLoading: false,
  error: "",
  SettingList: [],
  SettingDetail: {
    SettingKey: "",
    SettingType: "",
    SettingValue: "",
    IsActive: true,
  },
  isDeleteModalOpen: false,
  DeleteSettingID: null,
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    clearSettingDetails: (state) => {
      state.SettingDetail = initialState.SettingDetail;
    },
    openDeleteModal: (state, action: PayloadAction<number>) => {
      state.isDeleteModalOpen = true;
      state.DeleteSettingID = action.payload;
    },
    closeDeleteModal: (state) => {
      state.isDeleteModalOpen = false;
      state.DeleteSettingID = null;
    },
  },
  extraReducers: (builder) => {
    // Find All Settings
    builder.addCase(findAllSetting.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(findAllSetting.fulfilled, (state, action) => {
      state.loading = false;
      state.SettingList = action.payload || [];
    });
    builder.addCase(findAllSetting.rejected, (state, action: any) => {
      state.loading = false;
      state.error = action.payload?.message || "Something went wrong";
    });

    // Find Setting By ID
    builder.addCase(findByIDSetting.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(findByIDSetting.fulfilled, (state, action) => {
      state.formLoading = false;
      state.SettingDetail = action.payload;
    });
    builder.addCase(findByIDSetting.rejected, (state, action: any) => {
      state.formLoading = false;
      state.error = action.payload?.message || "Something went wrong";
    });

    // Insert Setting
    builder.addCase(insertSetting.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(insertSetting.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(insertSetting.rejected, (state) => {
      state.formLoading = false;
    });

    // Update Setting
    builder.addCase(updateSetting.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(updateSetting.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateSetting.rejected, (state) => {
      state.formLoading = false;
    });

    // Delete Setting
    builder.addCase(deleteSetting.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteSetting.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteSetting.rejected, (state) => {
      state.loading = false;
    });

    // Active/Inactive Setting
    builder.addCase(activeInactiveSetting.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(activeInactiveSetting.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactiveSetting.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { clearSettingDetails, openDeleteModal, closeDeleteModal } =
  settingSlice.actions;

export default settingSlice.reducer;
